import Constants from "./Constants";
import DetectRTC from "detectrtc";
const Peer = require("simple-peer");
import store from "./../store";
export default class ScreenShareController {
  constructor(sendMessage, showWebrtcStream, isMobile, turnConfs) {
    this.sendMessage = sendMessage;
    this.showWebrtcStream = showWebrtcStream;
    this.active = false;
    this.isMobile = isMobile;
    this.turnConfs = turnConfs;
    DetectRTC.load();
  }

  onMessage(msj) {
    if (msj.subtype === Constants.WS_REQUEST_SCREEN) {
      if (this.isMobile) {
        this.sendError(Constants.WS_NOT_SUPPORTED);
      } else if (!this.active) {
        this.showWebrtcStream.dialog = true;
      }
    } else if (msj.subtype === Constants.WS_SIGNALLING) {
      if (!this.peer) {
        this.initPeer(false);
        this.peer.signal(msj.content);
      } else {
        this.peer.signal(msj.content);
      }
    }
  }

  cancelShareScreen() {
    this.showWebrtcStream.dialog = false;
    this.sendError(Constants.WS_DENIED);
  }

  async shareScreen() {
    this.showWebrtcStream.dialog = false;
    this.active = true;
    let stream = await this.getDisplayMedia();
    if (stream) {
      this.initPeer(true, stream);
    } else {
      this.active = false;
      this.sendError(Constants.WS_DENIED);
    }
  }

  sendError(err) {
    const campaignName = window.location.hash
      .split("&")
      .find((h) => h.includes("campaign"))
      .split("=")[1];

    const index = store.state.findIndex(
      (e) => e.configuration.campaign === campaignName
    );

    let msj = {
      type: "webchat",
      subtype: Constants.WS_REQUEST_SCREEN,
      content: err,
      source: store.state[index].client.guid,
      guid: store.state[index].interaction.guid,
    };

    this.sendMessage(msj);
  }

  async getDisplayMedia() {
    try {
      this.stream = await navigator.mediaDevices.getDisplayMedia({
        video: true,
      });
    } catch (ex) {
      this.stream = null;
      console.error(ex);
    }
    return this.stream;
  }

  /**
   * Retorna la configuración de servidor de stun y turn.
   * @returns Retorna la configuración de servidor de stun y turn tal como se precisa para iniciar una conexión con un Peer.
   */
  getTurnCredentials() {
    let result;
    if (
      this.turnConfs.TurnServer &&
      this.turnConfs.TurnUser &&
      this.turnConfs.TurnPassword
    ) {
      result = {
        urls: [
          "turn:" + this.turnConfs.TurnServer,
          "stun:stun.l.google.com:19302",
          "stun:stun.ucontactcloud.com",
        ],
        username: this.turnConfs.TurnUser,
        credential: this.turnConfs.TurnPassword,
      };
    } else {
      result = {
        urls: ["stun:stun.l.google.com:19302", "stun:stun.ucontactcloud.com"],
      };
    }
    console.log(result);
    return result;
  }

  initPeer(initiator, stream) {
    this.peer = new Peer({
      initiator,
      stream,
      config: {
        iceServers: [ this.getTurnCredentials() ],
      },
    });
    this.peer.on("signal", (data) => {
      const campaignName = window.location.hash
        .split("&")
        .find((h) => h.includes("campaign"))
        .split("=")[1];

      const index = store.state.findIndex(
        (e) => e.configuration.campaign === campaignName
      );

      this.sendMessage({
        type: "webchat",
        subtype: Constants.WS_SIGNALLING,
        content: data,
        source: store.state[index].client.guid,
        guid: store.state[index].interaction.guid,
      });
    });

    this.peer.on("stream", (stream) => {
      this.showWebrtcStream.visible = true;
      this.showWebrtcStream.stream = stream;
    });

    this.peer.on("close", () => {
      this.onCloseConnection();
    });

    this.peer.on("error", (err) => {
      this.onCloseConnection();
      console.log(err);
    });

    if (stream) {
      stream.getVideoTracks()[0].onended = () => {
        this.closeStream();
      };
    }
  }

  onCloseConnection() {
    this.showWebrtcStream.visible = false;
    this.active = false;
    this.peer = null;
    if (this.stream)
      this.stream.getTracks().forEach((track) => {
        track.stop();
      });
  }

  closeStream() {
    if (this.peer) this.peer.destroy();
  }
}
